// extracted by mini-css-extract-plugin
export default {"wrapper":"SocialNetworks_wrapper__+JAgO","disabled":"SocialNetworks_disabled__lSQem","content":"SocialNetworks_content__uc9D9"};